import { useMemo } from "react";

import { getGroupName } from "../../utils";

export const useGroupName = (groupId: string, name?: string) =>
	useMemo(() => getGroupName(groupId, name), [groupId, name]);
